/**
 * @since 2018/9/7
 * @author fanjingjian
 */

export const SUBMIT_ERROR_CODE_LIST = [2009, 2010]; // 存在重复的未审批通过的字段报错提交, 需要上传图片并添加描述重新提交
export const DEFAULT_ID = -1;
export const defaultProvinceList = [{ provinceId: DEFAULT_ID, provinceName: '全部' }];
export const defaultCityList = [{ cityId: DEFAULT_ID, cityName: '全部' }];
export const defaultDistrictList = [{ districtId: DEFAULT_ID, districtName: '全部' }];
export const defaultRegionList = [{ regionId: DEFAULT_ID, regionName: '全部' }];
// 记录能够被提交的字段，防止用于展示的描述字段被提交
export const keys_can_be_patch_in_shop = [
  'dpShopId',
  'mtShopId',
  'shopName',
  'address',
  'phoneList',
  'latitude',
  'longitude',
  'backCateList',
  'accurateStatus',
  'power',
  'shopGroupId',
  'branchName',
  'crossRoad',
  'businessHours',
  'dpCityId',
  'dpDistrictId',
  'dpRegionId',
  'mtCityId',
  'mtDistrictId',
  'mtRegionId',
  'useType',
  'comment',
  'picInfos',
  'businessHoursObj',
  'auditMerchant', // MDC报错时，如报错人属于商服组织架构, 1:核审成功,0:未核审成功,默认不传null
];
// 门店状态报错相关数据
export const SHOP_STATUSINFO = {
  SHOP_USETYPE_NORMAL: 1,
  SHOP_STATUS_OPEN: 5, // 营业中
  SHOP_STATUS_CLOSE: 1, // 已关门
  SHOP_STATUS_STOP: 2, // 暂停营业
  SHOP_STATUS: [5, 2, 4, 1],
  SPECIAL_SHOP_TYPE: [826, 116, 807, 808, 809, 810, 811, 812, 813, 822, 2160], // 特殊类目报开上传资质
  FAKE_SHOP_TYPE: 6, // 虚假门店
  GARBAGE_SHOP_TYPE: 13, // 垃圾门店
  INFRINGEMENT_SHOP_TYPE: 15, // 侵权门店
  YELLO_SHOP_TYPE: 21, // 涉黄门店
  ERROR_SHOP_TYPE: [15, 21], // 不能报开的门店的 useType
  PROBLEM_SHOP_TYPE: [6, 13, 19, 20], // 报开需要上传资质的 useType
  SHOP_STATUS_NAME: {
    1: '停业',
    2: '暂停营业',
    4: '即将开业',
    5: '正常营业',
  },
  SHOP_STATUS_DESC: {
    1: '门店已经关门、转让或搬迁，长时间没有恢复营业的计划，无法提供服务',
    2: '门店因节假日、装修等原因，短期内停止营业，预计一段时间后恢复营业',
    4: '门店正在筹备阶段，暂时不能提供服务，完成准备后可以正式为顾客提供服务',
    5: '门店正常开放，能够为顾客提供服务',
  },
  SHOP_STATUS_MAP: {
    close: [1, 3, 6, 13, 15],
    suspend: [2],
    prepare: [4],
    open: [0, 5],
  },
};
// 核实途径枚举
export const verificationMethodArr = [
  {
    label: '到店核实',
    value: 1,
  },
  {
    label: '与商家远程核实',
    value: 2,
  },
  {
    label: '其他途径核实',
    value: 3,
    input: {
      placeholder: '请输入核实途径，2-100字',
      maxLength: 100,
    },
  },
];

// 婚宴副本报错相关数据
export const WEDDING_INFO = {
  WEDDING_ADD: 'add',
  WEDDING_RELATION: 'addRelation',
  WEDDING_DELETE: 'delRelation',
  WEDDING_MARRY: 55, // 结婚类目
  WEDDING_FOOD: 10, // 饭店
  WEDDING_HOTELS: 60, // 酒店
};

// 不校验营业状态的路径
export const NOT_CHECK_STATUS_PATH = [
  '/errors/shop-status',
  '/errors/repeat/merge',
  '/errors/repeat/split',
  '/errors/result/success',
  '/errors/groupon/service',
];

// 新旧店ruleCode 改前商户名中包含餐饮大客词: r300001473; 改后商户名中包含餐饮大客词:r300001474, 商户跨二级类目修改:r300001472
export const RULE_CODE = ['r300001473', 'r300001474', 'r300001472'];
// 后审中禁止报错 https://km.sankuai.com/collabpage/1804434083
export const isShopAuditing = ({ useType, appSides }) => useType === 38 && appSides === '1112';

// 1137(医药健康专用) 1140(中小发新企业务专用) 1141(易生活新企业务专用) 1142(下沉新企业务专用) 1139(自助设备业务专用)
export const BUSINESS_SPECIFIC_APPSIDES = [
  '1121',
  '1125',
  '1129',
  '1137',
  '1140',
  '1141',
  '1142',
  '1139',
];

export const POI_TYPE_CHANGED_ALERT = {
  isGrayPoi: '检测到您已修改⻔店类型，请上传【门头图】，可提高审核通过率',
  isBusinessSpecificPoi:
    '检测到您已修改门店类型，请上传带有门店名称的门头图。若招牌尚未安装，请上传门店环境图片',
};

export const POSITION_CHANGE_TIPS = {
  checkPosition: '检测到您修改了门店地址，不要忘记确认地图位置', // 变更位置后出现Tips 对应于“前往新地址”气泡
  confirmPosition: '拖动地图可调整位置，调整完成请点击确认，否则无法提交', // 确认位置Tips， 对应于“确认/取消”气泡
};
